import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { URLS } from '../constants';
import UrlList from '../components/url_list';
import Navbar from './navbar';
import ActionMenuButton from '../components/action_button';
import Preloader from '../components/preloader';
import GeneralMap from '../components/dashboard/GeneralMap';
import { setFieldView, fetchFieldInfo } from '../actions/map_actions';
import kauMap from '../img/kauSatelliteMap_final.jpg';
import keaauMap from '../img/keaauMap_final.jpg';
import { KAU_FIELD_MAP, KEAAU_FIELD_MAP } from '../constants';


class Main extends Component {
  constructor(props) {
    super(props);
    this.state = {
      field: null
    };
  }
  componentDidMount() {

  }
  render() {
    if (!this.props.user) return <span></span>;
    return (
      <div>
        <Navbar />
        <div id="main-body">
        {
          this.props.mapView ?
          <div id="map-view">
            <div id="preloader"><center><Preloader /></center></div>
            <div id="map-field-view">
              <center><h4>{this.props.field ? <div>Field: <b>{this.props.field}</b></div> : ''}</h4></center>
            </div>
            { this.props.location === 'kau' ?
              <center>
                <GeneralMap onclick={this.props.fetchFieldInfo} onmouseover={this.props.setFieldView}
                  _map={kauMap} fields={KAU_FIELD_MAP} mapId={'kaumap'} id={'kauMap'}
                  selectedField={this.props.selectedFieldInfo} fieldHours={this.props.fieldHours}
                  fieldHoursByDate={this.props.fieldHoursByDate} lastVisited={this.props.lastVisited}
                  harvest={this.props.harvest} work={this.props.work}
                />
              </center>
              :
              <center>
                <GeneralMap onclick={this.props.fetchFieldInfo} onmouseover={this.props.setFieldView}
                  _map={keaauMap} fields={KEAAU_FIELD_MAP} mapId={'keaaumap'} id={'keaauMap'}
                  selectedField={this.props.selectedFieldInfo} fieldHours={this.props.fieldHours}
                  fieldHoursByDate={this.props.fieldHoursByDate}
                />
              </center>
            }
          </div>
          : <div className="row" id="push">
            <div className="col s12 m12 l1 xl1 nav">
              <UrlList listItems={URLS} _class={'side-navigation'} id={'url-nav'} />
            </div>
            <div className="col s12 m12 l11 xl11 content">
              <div id="preloader"><center><Preloader /></center></div>
              { this.props.children }
            </div>
          </div>
        }
        </div>
        <div className="hide-on-large-only"><ActionMenuButton urls={URLS} /></div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    authenticated: state.auth.authenticated,
    message: state.auth.message,
    user: state.auth.user,
    payPeriod: state.misc.payPeriod,
    mapView: state.misc.mapView,
    field: state.misc.field,
    location: state.misc.location,
    selectedFieldInfo: state.misc.fieldInfo.basicInfo,
    fieldHours: state.misc.fieldInfo.hours,
    lastVisited: state.misc.fieldInfo.lastVisited,
    harvest: state.misc.fieldInfo.harvest,
    work: state.misc.fieldInfo.work
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    setFieldView,
    fetchFieldInfo
  }, dispatch);
}


export default connect(mapStateToProps, mapDispatchToProps)(Main);



/* END */



// WEBPACK FOOTER //
// ./src/containers/main.js